import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";

import { ChangeContext, LabelType, Options } from "@m0t0r/ngx-slider";
import { isNumeric } from "rxjs/internal-compatibility";

import { MarketplaceSearchForm } from "../../forms/marketplace-search.form";

@Component({
    selector: "pcg-ng-price-range-filter",
    template: require('./price-range-filter.component.html')
})
export class PriceRangeFilterComponent implements OnInit {
    private static readonly MIN_RANGE_LIMIT: number = 0;
    private static readonly MAX_RANGE_LIMIT: number = 500;

    @Input()
    public searchForm: MarketplaceSearchForm;

    public rangeSliderControl: FormControl;

    public rangeSliderOptions: Options = {
        floor: PriceRangeFilterComponent.MIN_RANGE_LIMIT,
        ceil: PriceRangeFilterComponent.MAX_RANGE_LIMIT,
        step: 10,
        animate: false,
        noSwitching: true,
        showTicksValues: true,
        tickStep: PriceRangeFilterComponent.MAX_RANGE_LIMIT,
        tickValueStep: PriceRangeFilterComponent.MAX_RANGE_LIMIT,
        translate: (value: number, label: LabelType): string => PriceRangeFilterComponent.formatLabelValue(value, label),
        ariaLabel: "minimum price slider",
        ariaLabelHigh: "maximum price slider"
    };

    private lastSubmittedState: Array<number> = [PriceRangeFilterComponent.MIN_RANGE_LIMIT, PriceRangeFilterComponent.MAX_RANGE_LIMIT];

    private static formatLabelValue(value: number, label: LabelType): string {
        switch (label) {
            case LabelType.Low: {
                return `<b>Min price:</b> £${value}`;
            }
            case LabelType.High: {
                if (value === this.MAX_RANGE_LIMIT) {
                    return `<b>Max price:</b> £${this.MAX_RANGE_LIMIT}+`;
                } else {
                    return `<b>Max price:</b> £${value}`;
                }
            }
            default: {
                if (value === this.MAX_RANGE_LIMIT) {
                    return `£${this.MAX_RANGE_LIMIT}+`;
                } else {
                    return `£${value}`;
                }
            }
        }
    }

    public ngOnInit(): void {
        const minPrice = this.searchForm.minPrice.value as string;
        const maxPrice = this.searchForm.maxPrice.value as string;

        let lowValue: number = isNumeric(minPrice) ? parseInt(minPrice, 10) : PriceRangeFilterComponent.MIN_RANGE_LIMIT;
        let highValue: number = isNumeric(maxPrice) ? parseInt(maxPrice, 10) : PriceRangeFilterComponent.MAX_RANGE_LIMIT;

        if ((lowValue < PriceRangeFilterComponent.MIN_RANGE_LIMIT) || (lowValue > PriceRangeFilterComponent.MAX_RANGE_LIMIT)) {
            lowValue = PriceRangeFilterComponent.MIN_RANGE_LIMIT;
        }
        if ((highValue < PriceRangeFilterComponent.MIN_RANGE_LIMIT) || (highValue > PriceRangeFilterComponent.MAX_RANGE_LIMIT)) {
            highValue = PriceRangeFilterComponent.MAX_RANGE_LIMIT;
        }

        this.lastSubmittedState = [Math.min(lowValue, highValue), Math.max(lowValue, highValue)];
        this.rangeSliderControl = new FormControl([this.lastSubmittedState[0], this.lastSubmittedState[1]]);
    }

    public onSelectedRangeChanged(changeContext: ChangeContext): void {
        const lowValue: number = this.rangeSliderControl.value[0];
        const highValue: number = this.rangeSliderControl.value[1];

        if ((lowValue === this.lastSubmittedState[0]) && (highValue === this.lastSubmittedState[1])) {
            return;
        }

        this.lastSubmittedState = [lowValue, highValue];

        this.searchForm.pageNumber.setValue(1, { emitEvent: false });

        this.searchForm.minPrice.setValue(lowValue.toString(), { emitEvent: false });
        this.searchForm.maxPrice.setValue(((highValue !== PriceRangeFilterComponent.MAX_RANGE_LIMIT) ? highValue.toString() : ""), { emitEvent: false });

        this.searchForm.submit();
    }
}
